export default "__VITE_ASSET__D7G1Ix5N__"